import axios from "axios";
import { all, call, fork, put, takeEvery } from "redux-saga/effects";
import * as actions from "../../reducers/membership/index";

function loadListAPI(payload) {
  return axios.get(`/api/eh/membership-club`, {
    params: { ...payload },
  });
}

function* loadList({ payload }) {
  console.log("payload: ============================== ", payload);

  yield put({
    type: actions.LOADING,
    payload: true,
  });

  try {
    const response = yield call(loadListAPI, payload);
    console.log("response: ", response);
    console.log("response.data.data: ", response.data.data);

    yield put({
      type: actions.LOAD_MEMBERSHIP_LIST_SUCCESS,
      payload: response.data.data,
    });
  } catch (error) {
    console.log("error: ", error);
  }

  yield put({
    type: actions.LOADING,
    payload: false,
  });
}

function loadDetailAPI(payload) {
  return axios.get(`/api/eh/membership-club/get`, {
    params: { ...payload },
  });
}

function* loadDetail({ payload }) {
  console.log("payload: ============================== ", payload);

  yield put({
    type: actions.INIT_MEMBERSHIP,
  });

  yield put({
    type: actions.LOADING,
    payload: true,
  });

  try {
    const response = yield call(loadDetailAPI, payload);
    console.log("response: ", response);
    console.log(
      "response.data.data.membershipClub: ",
      response.data.data.membershipClub
    );

    yield put({
      type: actions.LOAD_MEMBERSHIP_SUCCESS,
      payload: response.data.data.membershipClub,
    });
  } catch (error) {
    console.log("error: ", error);
  }

  yield put({
    type: actions.LOADING,
    payload: false,
  });
}

function loadImgAPI() {
  return axios.get(`/api/eh/membership-club/get-image`);
}

function* loadImg({ payload }) {
  console.log("payload: loadImg============================== ", payload);

  yield put({
    type: actions.LOADING,
    payload: true,
  });
  try {
    const response = yield call(loadImgAPI);
    console.log("response: ", response);
    console.log("response.data.data.imgUrl: ", response.data.data);

    yield put({
      type: actions.LOAD_MEMBERSHIP_IMG_SUCCESS,
      payload: response.data.data.imgUrl,
    });
  } catch (error) {
    console.log("error: ", error);
  }

  yield put({
    type: actions.LOADING,
    payload: false,
  });
}

function* watchLoadMembershipList() {
  yield takeEvery(actions.LOAD_MEMBERSHIP_LIST, loadList);
}

function* watchLoadMembership() {
  yield takeEvery(actions.LOAD_MEMBERSHIP, loadDetail);
}

function* watchLoadMembershipImg() {
  yield takeEvery(actions.LOAD_MEMBERSHIP_IMG, loadImg);
}

export default function* membershipSaga() {
  yield all([
    fork(watchLoadMembershipList),
    fork(watchLoadMembership),
    fork(watchLoadMembershipImg),
  ]);
}
